/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  Json: { input: any; output: any }
}

export type Address = Node & {
  __typename: 'Address'
  city?: Maybe<Scalars['String']['output']>
  countryCode: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  /** The id of the object. */
  id: Scalars['ID']['output']
  lines: Array<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
  zip?: Maybe<Scalars['String']['output']>
}

export type AddressCreatelinesInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum AddressOrderByInput {
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  CountryCodeAsc = 'countryCode_ASC',
  CountryCodeDesc = 'countryCode_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StreetAddressAsc = 'streetAddress_ASC',
  StreetAddressDesc = 'streetAddress_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ZipAsc = 'zip_ASC',
  ZipDesc = 'zip_DESC',
}

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>
  countryCode: Scalars['String']['input']
  lines?: InputMaybe<AddressCreatelinesInput>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type AddressWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AddressWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AddressWhereInput>>
  city?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  city_contains?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  countryCode_contains?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  streetAddress_contains?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  zip_contains?: InputMaybe<Scalars['String']['input']>
}

export type AggregateContainer = {
  __typename: 'AggregateContainer'
  count: Scalars['Int']['output']
}

export type AggregateSource = {
  __typename: 'AggregateSource'
  count: Scalars['Int']['output']
}

export type BatchPayload = {
  __typename: 'BatchPayload'
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Int']['output']
}

export type Container = ContainerDocument | ContainerReturn

export type ContainerConnection = {
  __typename: 'ContainerConnection'
  aggregate: AggregateContainer
  /** A list of edges. */
  edges: Array<ContainerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type ContainerDocument = ContainerNode & {
  __typename: 'ContainerDocument'
  /** Whether the current user can add the container to ReturnBasket */
  canReturn: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  /** Represents the status of the original. Value will be null For DigitalDocuments. */
  currentLocationType?: Maybe<OriginalStateType>
  documentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  /** This value is true for the documents that have been permanently deleted from trash */
  isDestroyed: Scalars['Boolean']['output']
  owner: Customer
  returnId?: Maybe<Scalars['ID']['output']>
  scanCenter?: Maybe<ScanCenterCode>
  scanMetadata?: Maybe<DocumentScanMetadata>
  senderMetadata?: Maybe<DocumentSenderMetadata>
  subject?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type ContainerEdge = {
  __typename: 'ContainerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Container
}

export type ContainerNode = {
  /** Whether the current user can add the container to ReturnBasket */
  canReturn: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

export enum ContainerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type ContainerReturn = {
  __typename: 'ContainerReturn'
  address?: Maybe<Address>
  id: Scalars['ID']['output']
  owner: ContainerReturnOwner
  requestedAt?: Maybe<Scalars['DateTime']['output']>
  requesterUser: ContainerReturnRequesterUser
  sentAt?: Maybe<Scalars['DateTime']['output']>
  type: ContainerTypeReturn
}

export type ContainerReturnOwner = {
  __typename: 'ContainerReturnOwner'
  encodedPublicId: Scalars['String']['output']
  id: Scalars['ID']['output']
  publicId: Scalars['Int']['output']
}

export type ContainerReturnRequesterUser = {
  __typename: 'ContainerReturnRequesterUser'
  email?: Maybe<Scalars['String']['output']>
}

export enum ContainerType {
  DeletedCopy = 'DeletedCopy',
  DeletedShare = 'DeletedShare',
  DocumentDigital = 'DocumentDigital',
  DocumentScan = 'DocumentScan',
  Folder = 'Folder',
  FolderArchive = 'FolderArchive',
  FolderDestroyed = 'FolderDestroyed',
  FolderDestroying = 'FolderDestroying',
  FolderInbox = 'FolderInbox',
  FolderSharedWithMe = 'FolderSharedWithMe',
  FolderTrash = 'FolderTrash',
  ReturnBasket = 'ReturnBasket',
  ReturnImmediate = 'ReturnImmediate',
  ReturnScheduled = 'ReturnScheduled',
  ShredBasket = 'ShredBasket',
  StorageLongTerm = 'StorageLongTerm',
  StorageShortTerm = 'StorageShortTerm',
}

export enum ContainerTypeFolder {
  Folder = 'Folder',
  FolderArchive = 'FolderArchive',
  FolderDestroyed = 'FolderDestroyed',
  FolderDestroying = 'FolderDestroying',
  FolderInbox = 'FolderInbox',
  FolderSharedWithMe = 'FolderSharedWithMe',
  FolderTrash = 'FolderTrash',
}

export enum ContainerTypeMetadataOriginal {
  ReturnBasket = 'ReturnBasket',
  ReturnImmediate = 'ReturnImmediate',
  ReturnScheduled = 'ReturnScheduled',
  ShredBasket = 'ShredBasket',
  StorageLongTerm = 'StorageLongTerm',
  StorageShortTerm = 'StorageShortTerm',
}

export enum ContainerTypeReturn {
  ReturnBasket = 'ReturnBasket',
  ReturnImmediate = 'ReturnImmediate',
  ReturnScheduled = 'ReturnScheduled',
}

export type ContainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContainerWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContainerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContainerWhereInput>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  document?: InputMaybe<DocumentWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  /** All values that are not equal to given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  metadataOriginal?: InputMaybe<MetadataOriginalWhereInput>
  metadataReturn?: InputMaybe<MetadataReturnWhereInput>
  owner?: InputMaybe<CustomerWhereInput>
  type?: InputMaybe<ContainerType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<ContainerType>>
  /** All values that are not equal to given value. */
  type_not?: InputMaybe<ContainerType>
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<ContainerType>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContainerWhereUniqueInput = {
  id: Scalars['ID']['input']
}

export type Customer = Node & {
  __typename: 'Customer'
  address?: Maybe<Address>
  captureSettings: CustomerCaptureSettings
  companyName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  encodedPublicId: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  /** The id of the object. */
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  metabaseDashboardId?: Maybe<Scalars['String']['output']>
  newsletter: Scalars['Boolean']['output']
  paywalledAt?: Maybe<Scalars['DateTime']['output']>
  planId: Scalars['String']['output']
  publicId?: Maybe<Scalars['Int']['output']>
  returnsAll: Scalars['Boolean']['output']
  returnsInterval?: Maybe<ReturnsInterval>
  returnsNextAt?: Maybe<Scalars['DateTime']['output']>
  scanCenter: ScanCenterCode
  updatedAt: Scalars['DateTime']['output']
}

export type CustomerCaptureSettings = {
  __typename: 'CustomerCaptureSettings'
  automaticTransferEnabled: Scalars['Boolean']['output']
  disabledChecks: Array<DocumentCaptureCheck>
}

export type CustomerCaptureSettingsInput = {
  automaticTransferEnabled: Scalars['Boolean']['input']
  disabledChecks: Array<DocumentCaptureCheck>
}

export enum CustomerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type CustomerReturnScheduleUpdateInput = {
  returnsInterval: ReturnSchedule
  returnsNextAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CustomerUpdateEmailInput = {
  email: Scalars['String']['input']
  id: Scalars['ID']['input']
}

export type CustomerUpdateScanCenterInput = {
  scanCenter: ScanCenterCode
}

export type CustomerWhereByEmailOrEncodedPublicIdInput = {
  encodedPublicId?: InputMaybe<Scalars['String']['input']>
  stage: ReassignDocumentStage
}

export type CustomerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CustomerWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CustomerWhereInput>>
  address?: InputMaybe<AddressWhereInput>
  companyName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<Scalars['String']['input']>>
  firstName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  firstName_contains?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  /** All values that are not equal to given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  lastName_contains?: InputMaybe<Scalars['String']['input']>
  planId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  planId_contains?: InputMaybe<Scalars['String']['input']>
  publicId?: InputMaybe<Scalars['Int']['input']>
  /** All values that are contained in given list. */
  publicId_in?: InputMaybe<Array<Scalars['Int']['input']>>
  scanCenter?: InputMaybe<ScanCenterCode>
  /** All values that are contained in given list. */
  scanCenter_in?: InputMaybe<Array<ScanCenterCode>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type CustomerWhereUniqueInput = {
  id: Scalars['ID']['input']
}

export type Document = Node & {
  __typename: 'Document'
  createdAt: Scalars['DateTime']['output']
  customer?: Maybe<Customer>
  fileToken: Scalars['String']['output']
  /** The id of the object. */
  id: Scalars['ID']['output']
  natifMetadata?: Maybe<DocumentNatifMetadata>
  paymentMetadata?: Maybe<PaymentMetadata>
  recipientMetadata?: Maybe<DocumentRecipientMetadata>
  rules?: Maybe<Array<DocumentRule>>
  scanCenter?: Maybe<ScanCenterCode>
  scanMetadata?: Maybe<DocumentScanMetadata>
  senderMetadata?: Maybe<DocumentSenderMetadata>
  stage: DocumentStage
  subject?: Maybe<Scalars['String']['output']>
  tagger?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum DocumentCaptureCheck {
  CustomerNamesAll = 'CustomerNamesAll',
  PublicIdAll = 'PublicIdAll',
}

export type DocumentNatifMetadata = {
  __typename: 'DocumentNatifMetadata'
  /** scan date either in `yyyyMMdd` or `yyyyMMddTHHmmZ` */
  date?: Maybe<Scalars['String']['output']>
  scanId?: Maybe<Scalars['String']['output']>
}

export type DocumentNatifMetadataUpdateInput = {
  date?: InputMaybe<Scalars['String']['input']>
  scanId?: InputMaybe<Scalars['String']['input']>
}

export enum DocumentOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export type DocumentRecipientMetadata = {
  __typename: 'DocumentRecipientMetadata'
  name?: Maybe<Scalars['String']['output']>
}

export type DocumentRecipientMetadataUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type DocumentRule = Node & {
  __typename: 'DocumentRule'
  /** The id of the object. */
  id: Scalars['ID']['output']
  metadata?: Maybe<Scalars['Json']['output']>
  severity: DocumentRuleSeverity
  type: DocumentRuleType
}

export enum DocumentRuleOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MetadataAsc = 'metadata_ASC',
  MetadataDesc = 'metadata_DESC',
  SeverityAsc = 'severity_ASC',
  SeverityDesc = 'severity_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export enum DocumentRuleSeverity {
  Error = 'Error',
  Info = 'Info',
  Warning = 'Warning',
}

export enum DocumentRuleType {
  AutomaticProcess = 'AutomaticProcess',
  CustomerNamesDontMatchPublicId = 'CustomerNamesDontMatchPublicId',
  CustomerNamesNone = 'CustomerNamesNone',
  CustomerNamesNotFound = 'CustomerNamesNotFound',
  DatabreachWarning = 'DatabreachWarning',
  PublicIdDoesntExist = 'PublicIdDoesntExist',
  PublicIdFuzzy = 'PublicIdFuzzy',
  PublicIdIncorrect = 'PublicIdIncorrect',
  PublicIdInvalid = 'PublicIdInvalid',
  PublicIdMoreThanOne = 'PublicIdMoreThanOne',
  PublicIdNone = 'PublicIdNone',
  PublicIdsDontMatch = 'PublicIdsDontMatch',
}

export type DocumentRuleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DocumentRuleWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DocumentRuleWhereInput>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  severity?: InputMaybe<DocumentRuleSeverity>
  /** All values that are contained in given list. */
  severity_in?: InputMaybe<Array<DocumentRuleSeverity>>
  type?: InputMaybe<DocumentRuleType>
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<DocumentRuleType>>
}

export type DocumentScanMetadata = {
  __typename: 'DocumentScanMetadata'
  /** scan date either in `yyyyMMdd` or `yyyyMMddTHHmmZ` */
  date?: Maybe<Scalars['String']['output']>
  scanId?: Maybe<Scalars['String']['output']>
  sequenceId?: Maybe<Scalars['String']['output']>
}

export type DocumentSenderMetadata = {
  __typename: 'DocumentSenderMetadata'
  email?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type DocumentSenderMetadataUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export enum DocumentStage {
  Deleted = 'Deleted',
  Done = 'Done',
  Finished = 'Finished',
  IngestionCompleted = 'IngestionCompleted',
  ManualProcessingStarted = 'ManualProcessingStarted',
  ManualProcessingToBeDeleted = 'ManualProcessingToBeDeleted',
  NatifProcessed = 'NatifProcessed',
  NatifUploaded = 'NatifUploaded',
  Open = 'Open',
  PendingTransfer = 'PendingTransfer',
  PreProcessing = 'PreProcessing',
  Processing = 'Processing',
  Rejected = 'Rejected',
  RejectedForReScan = 'RejectedForReScan',
  Started = 'Started',
  Transferred = 'Transferred',
  Validated = 'Validated',
}

export type DocumentUpdateInput = {
  natifMetadata?: InputMaybe<DocumentNatifMetadataUpdateInput>
  recipientMetadata?: InputMaybe<DocumentRecipientMetadataUpdateInput>
  sender?: InputMaybe<DocumentSenderMetadataUpdateInput>
  stage?: InputMaybe<DocumentStage>
  subject?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<DocumentUpdatetagsInput>
}

export type DocumentUpdatetagsInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type DocumentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DocumentWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DocumentWhereInput>>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  customer?: InputMaybe<CustomerWhereInput>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  rules_every?: InputMaybe<DocumentRuleWhereInput>
  rules_none?: InputMaybe<DocumentRuleWhereInput>
  rules_some?: InputMaybe<DocumentRuleWhereInput>
  scanCenter?: InputMaybe<ScanCenterCode>
  /** All values that are not equal to given value. */
  scanCenter_not?: InputMaybe<ScanCenterCode>
  stage?: InputMaybe<DocumentStage>
  /** All values that are contained in given list. */
  stage_in?: InputMaybe<Array<DocumentStage>>
  /** All values that are not equal to given value. */
  stage_not?: InputMaybe<DocumentStage>
  /** All values that are not contained in given list. */
  stage_not_in?: InputMaybe<Array<DocumentStage>>
  tagger?: InputMaybe<Scalars['String']['input']>
  /** All values that are contained in given list. */
  tagger_in?: InputMaybe<Array<Scalars['String']['input']>>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type DocumentWhereUniqueInput = {
  id: Scalars['ID']['input']
}

/**
 * `DocumentExceedsLimit`: Uploaded scan file exceeds natif limits such as max pages, max size and etc.
 * `Rejected`: Catch all case for processing pipeline errors.
 * `UnSupportedMedia`: Uploaded scan file is not a PDF or corrupted.
 */
export enum FailedDocumentType {
  DocumentExceedsLimit = 'DocumentExceedsLimit',
  Rejected = 'Rejected',
  UnSupportedMedia = 'UnSupportedMedia',
}

export type IncorrectOrRejectedFile = {
  __typename: 'IncorrectOrRejectedFile'
  file: Scalars['String']['output']
  key: Scalars['String']['output']
  type: FailedDocumentType
}

export type IncorrectOrRejectedFileUpdateInput = {
  newFileName: Scalars['String']['input']
}

export type IncorrectOrRejectedFileWhereInput = {
  key: Scalars['String']['input']
}

export type KundentabelleRowData = {
  __typename: 'KundentabelleRowData'
  businessName?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  contactName?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type MetadataOriginalContainerWhereInput = {
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MetadataOriginalWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetadataOriginalWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetadataOriginalWhereInput>>
  currentLocation?: InputMaybe<MetadataOriginalContainerWhereInput>
  currentLocationType?: InputMaybe<OriginalStateType>
  /** All values that are contained in given list. */
  currentLocationType_in?: InputMaybe<Array<OriginalStateType>>
  /** All values that are not equal to given value. */
  currentLocationType_not?: InputMaybe<OriginalStateType>
  /** All values that are not contained in given list. */
  currentLocationType_not_in?: InputMaybe<Array<OriginalStateType>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  nextLocationType?: InputMaybe<OriginalStateType>
  /** All values that are contained in given list. */
  nextLocationType_in?: InputMaybe<Array<OriginalStateType>>
  /** All values that are not equal to given value. */
  nextLocationType_not?: InputMaybe<OriginalStateType>
  /** All values that are not contained in given list. */
  nextLocationType_not_in?: InputMaybe<Array<OriginalStateType>>
}

export type MetadataReturnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetadataReturnWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetadataReturnWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetadataReturnWhereInput>>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  sentAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type Mutation = {
  __typename: 'Mutation'
  assignTaggerDocuments: Array<Document>
  cloneSource: Source
  deleteDocument: Document
  /** Delete a pdf from the scan uploads buckets. */
  deleteUpload: Scalars['Boolean']['output']
  disableCustomer: Customer
  reAssignDocument?: Maybe<Document>
  renameUpload: Scalars['Boolean']['output']
  reportNatifExtractionErrors: Scalars['Boolean']['output']
  requestReturn: Array<ContainerReturn>
  /** Add Container to Return Basket */
  sendContainerDocument: ContainerDocument
  sendReturn: ContainerReturn
  /** Set the document capture settings for a customer. */
  setCustomerCaptureSettings: CustomerCaptureSettings
  /** Put/remove the customer behind a paywall manually. No access to document preview. */
  setCustomerPaywall: Customer
  setManyReturnTrackingIds: BatchPayload
  setSourceAddress: Source
  /** Set the Metabase dashboard ID for a tenant. */
  setTenantMetabaseDashboardId: Customer
  unDeleteContainerDocument: ContainerDocument
  unShredContainerDocument: ContainerDocument
  unassignDocument?: Maybe<Document>
  /** Sets the scan center for given customer */
  updateCustomer: Customer
  updateCustomerEmail: Customer
  updateCustomerReturnSchedule: Customer
  updateDocument: Document
  updateSource: Source
  upsertPaymentMetadata: Document
}

export type MutationAssignTaggerDocumentsArgs = {
  count?: Scalars['Int']['input']
  where?: InputMaybe<DocumentWhereInput>
}

export type MutationCloneSourceArgs = {
  where: SourceWhereUniqueInput
}

export type MutationDeleteDocumentArgs = {
  where: DocumentWhereUniqueInput
}

export type MutationDeleteUploadArgs = {
  where: IncorrectOrRejectedFileWhereInput
}

export type MutationDisableCustomerArgs = {
  where: CustomerWhereUniqueInput
}

export type MutationReAssignDocumentArgs = {
  data: CustomerWhereByEmailOrEncodedPublicIdInput
  where: DocumentWhereUniqueInput
}

export type MutationRenameUploadArgs = {
  data: IncorrectOrRejectedFileUpdateInput
  where: IncorrectOrRejectedFileWhereInput
}

export type MutationReportNatifExtractionErrorsArgs = {
  data: NatifExtractionErrorsInput
  where: NatifExtractionErrorsWhereInput
}

export type MutationRequestReturnArgs = {
  customerId: Scalars['ID']['input']
}

export type MutationSendContainerDocumentArgs = {
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}

export type MutationSendReturnArgs = {
  where: ContainerWhereUniqueInput
}

export type MutationSetCustomerCaptureSettingsArgs = {
  data: CustomerCaptureSettingsInput
  where: CustomerWhereUniqueInput
}

export type MutationSetCustomerPaywallArgs = {
  isPaywalled?: InputMaybe<Scalars['Boolean']['input']>
  where: CustomerWhereUniqueInput
}

export type MutationSetManyReturnTrackingIdsArgs = {
  data: Array<SetReturnTrackingIdInput>
}

export type MutationSetSourceAddressArgs = {
  data: AddressUpdateInput
  where: SourceWhereUniqueInput
}

export type MutationSetTenantMetabaseDashboardIdArgs = {
  data: SetTenantMetabaseDashboardIdInput
  where: CustomerWhereUniqueInput
}

export type MutationUnDeleteContainerDocumentArgs = {
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}

export type MutationUnShredContainerDocumentArgs = {
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}

export type MutationUnassignDocumentArgs = {
  where: DocumentWhereUniqueInput
}

export type MutationUpdateCustomerArgs = {
  data: CustomerUpdateScanCenterInput
  where: CustomerWhereUniqueInput
}

export type MutationUpdateCustomerEmailArgs = {
  data: CustomerUpdateEmailInput
}

export type MutationUpdateCustomerReturnScheduleArgs = {
  data: CustomerReturnScheduleUpdateInput
  where: CustomerWhereUniqueInput
}

export type MutationUpdateDocumentArgs = {
  data: DocumentUpdateInput
  where: DocumentWhereUniqueInput
}

export type MutationUpdateSourceArgs = {
  data: SourceUpdateInput
  where: SourceWhereUniqueInput
}

export type MutationUpsertPaymentMetadataArgs = {
  data: PaymentMetadataCreateWithoutDocumentInput
  where: DocumentWhereUniqueInput
}

export type NatifExtractionErrorFields = {
  /** Use this field to report that the document contains extraction errors */
  documentExtraction?: InputMaybe<Scalars['Boolean']['input']>
  /** Use this field to report that the document's tags contain extraction errors */
  tags?: InputMaybe<NatifExtractionErrorTagInput>
}

export type NatifExtractionErrorTagInput = {
  /** Use this field to report that the document's tag extraction contains errors */
  documentTag: Scalars['String']['input']
  /** Use this field to report that document extraction contains errors */
  senderTag: Scalars['String']['input']
}

export type NatifExtractionErrorsInput = {
  /** Document's metadata fields which contain errors in the extraction by Natif */
  errorFields: NatifExtractionErrorFields
}

export type NatifExtractionErrorsWhereInput = {
  /** The Caya document id which contains extraction errors */
  id: Scalars['ID']['input']
}

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output']
}

export enum OriginalStateType {
  PreparingReturnPacket = 'PreparingReturnPacket',
  ReturnBasket = 'ReturnBasket',
  ReturnImmediate = 'ReturnImmediate',
  ReturnPacketSent = 'ReturnPacketSent',
  ReturnScheduled = 'ReturnScheduled',
  ShredBasket = 'ShredBasket',
  StorageLongTerm = 'StorageLongTerm',
  StorageShortTerm = 'StorageShortTerm',
}

export type PageInfo = {
  __typename: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

export enum PaymentCurrencyCode {
  Chf = 'CHF',
  Eur = 'EUR',
}

export type PaymentMetadata = {
  __typename: 'PaymentMetadata'
  amount?: Maybe<Scalars['Float']['output']>
  iban?: Maybe<Scalars['String']['output']>
  recipient?: Maybe<Scalars['String']['output']>
  reference?: Maybe<Scalars['String']['output']>
}

export type PaymentMetadataCreateWithoutDocumentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  bic?: InputMaybe<Scalars['String']['input']>
  currencyCode?: InputMaybe<PaymentCurrencyCode>
  iban?: InputMaybe<Scalars['String']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
  reference?: InputMaybe<Scalars['String']['input']>
}

export type Query = {
  __typename: 'Query'
  containerDocument: ContainerDocument
  /** Supports ContainerReturn (return shipments) and ContainerDocument (documents in return shipment) queries only. */
  containersConnection: ContainerConnection
  customers: Array<Customer>
  document: Document
  documents: Array<Document>
  documentsInOpenReturn: Array<ContainerDocument>
  failedDocuments: Array<IncorrectOrRejectedFile>
  /** Queries kundentabelle to find tenants by their public ID. */
  fetchTenant: Array<KundentabelleRowData>
  findCustomers: Array<Customer>
  me: User
  sourcesConnection: SourceConnection
}

export type QueryContainerDocumentArgs = {
  containerId: Scalars['ID']['input']
}

export type QueryContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: Scalars['Int']['input']
  where?: InputMaybe<ContainerWhereInput>
}

export type QueryCustomersArgs = {
  first?: Scalars['Int']['input']
  where?: InputMaybe<CustomerWhereInput>
}

export type QueryDocumentArgs = {
  where: DocumentWhereUniqueInput
}

export type QueryDocumentsArgs = {
  first?: Scalars['Int']['input']
  where?: InputMaybe<DocumentWhereInput>
}

export type QueryDocumentsInOpenReturnArgs = {
  customerId: Scalars['ID']['input']
}

export type QueryFetchTenantArgs = {
  publicId: Scalars['String']['input']
}

export type QueryFindCustomersArgs = {
  searchText: Scalars['String']['input']
}

export type QuerySourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: Scalars['Int']['input']
  orderBy?: InputMaybe<SourceOrderByInput>
  where?: InputMaybe<SourceWhereInput>
}

export enum ReassignDocumentStage {
  ManualProcessingStarted = 'ManualProcessingStarted',
  Rejected = 'Rejected',
}

export enum ReturnSchedule {
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Off = 'OFF',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum ReturnsInterval {
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum ScanCenterCode {
  Atos = 'ATOS',
  Iab = 'IAB',
  Ods = 'ODS',
  Sps = 'SPS',
  Srz = 'SRZ',
}

export type SetReturnTrackingIdInput = {
  returnShipmentId: Scalars['String']['input']
  trackingId: Scalars['String']['input']
}

export type SetTenantMetabaseDashboardIdInput = {
  metabaseDashboardId: Scalars['String']['input']
}

export type Source = Node & {
  __typename: 'Source'
  address: Address
  createdAt: Scalars['DateTime']['output']
  customer: Customer
  duration?: Maybe<SourceInterval>
  endAt?: Maybe<Scalars['DateTime']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  /** The id of the object. */
  id: Scalars['ID']['output']
  metadata: Scalars['Json']['output']
  scanCenter: ScanCenterCode
  stage: SourceStage
  startAt?: Maybe<Scalars['DateTime']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type SourceConnection = {
  __typename: 'SourceConnection'
  aggregate: AggregateSource
  /** A list of edges. */
  edges: Array<SourceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type SourceEdge = {
  __typename: 'SourceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node: Source
}

export enum SourceInterval {
  HalfYearly = 'HalfYearly',
  Yearly = 'Yearly',
}

export enum SourceOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StageAsc = 'stage_ASC',
  StageDesc = 'stage_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

export enum SourceStage {
  Activated = 'Activated',
  Activating = 'Activating',
  Canceled = 'Canceled',
  Cancelling = 'Cancelling',
  Expired = 'Expired',
  Expiring = 'Expiring',
  NoExtension = 'NoExtension',
  Renewing = 'Renewing',
  Requested = 'Requested',
}

export type SourceUpdateInput = {
  duration?: InputMaybe<SourceInterval>
  externalId?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['Json']['input']>
  scanCenter?: InputMaybe<ScanCenterCode>
  stage?: InputMaybe<SourceStage>
  startAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type SourceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SourceWhereInput>>
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SourceWhereInput>>
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SourceWhereInput>>
  address?: InputMaybe<AddressWhereInput>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  customer?: InputMaybe<CustomerWhereInput>
  duration?: InputMaybe<SourceInterval>
  /** All values that are contained in given list. */
  duration_in?: InputMaybe<Array<SourceInterval>>
  /** All values that are not equal to given value. */
  duration_not?: InputMaybe<SourceInterval>
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  endAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  endAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  externalId?: InputMaybe<Scalars['String']['input']>
  /** All values containing the given string. */
  externalId_contains?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>
  scanCenter?: InputMaybe<ScanCenterCode>
  /** All values that are contained in given list. */
  scanCenter_in?: InputMaybe<Array<ScanCenterCode>>
  /** All values that are not equal to given value. */
  scanCenter_not?: InputMaybe<ScanCenterCode>
  /** All values that are not contained in given list. */
  scanCenter_not_in?: InputMaybe<Array<ScanCenterCode>>
  stage?: InputMaybe<SourceStage>
  /** All values that are contained in given list. */
  stage_in?: InputMaybe<Array<SourceStage>>
  /** All values that are not equal to given value. */
  stage_not?: InputMaybe<SourceStage>
  /** All values that are not contained in given list. */
  stage_not_in?: InputMaybe<Array<SourceStage>>
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  startAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  startAt_lte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type SourceWhereUniqueInput = {
  id: Scalars['ID']['input']
}

export type User = {
  __typename: 'User'
  groups: Array<Scalars['String']['output']>
  username: Scalars['String']['output']
}

export type CustomerAddressFragment = {
  __typename: 'Address'
  id: string
  lines: Array<string>
  streetAddress?: string | null
  city?: string | null
  zip?: string | null
  countryCode: string
  createdAt: any
  updatedAt: any
}

export type CustomerFragment = {
  __typename: 'Customer'
  id: string
  publicId?: number | null
  encodedPublicId: string
  planId: string
  email: string
  firstName?: string | null
  lastName?: string | null
  companyName?: string | null
  metabaseDashboardId?: string | null
  newsletter: boolean
  returnsInterval?: ReturnsInterval | null
  scanCenter: ScanCenterCode
  paywalledAt?: any | null
  returnsAll: boolean
  returnsNextAt?: any | null
  createdAt: any
  updatedAt: any
  address?: {
    __typename: 'Address'
    id: string
    lines: Array<string>
    streetAddress?: string | null
    city?: string | null
    zip?: string | null
    countryCode: string
    createdAt: any
    updatedAt: any
  } | null
  captureSettings: {
    __typename: 'CustomerCaptureSettings'
    automaticTransferEnabled: boolean
    disabledChecks: Array<DocumentCaptureCheck>
  }
}

export type CustomersQueryVariables = Exact<{
  where: CustomerWhereInput
  first?: InputMaybe<Scalars['Int']['input']>
}>

export type CustomersQuery = {
  __typename: 'Query'
  customers: Array<{
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }>
}

export type DisableCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DisableCustomerMutation = {
  __typename: 'Mutation'
  disableCustomer: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }
}

export type FetchTenantQueryVariables = Exact<{
  publicId: Scalars['String']['input']
}>

export type FetchTenantQuery = {
  __typename: 'Query'
  fetchTenant: Array<{
    __typename: 'KundentabelleRowData'
    contactName?: string | null
    businessName?: string | null
    firstName?: string | null
    lastName?: string | null
    streetAddress?: string | null
    zipCode?: string | null
    city?: string | null
  }>
}

export type FindCustomerQueryVariables = Exact<{
  searchText: Scalars['String']['input']
}>

export type FindCustomerQuery = {
  __typename: 'Query'
  findCustomers: Array<{
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }>
}

export type SetCustomerCaptureSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input']
  data: CustomerCaptureSettingsInput
}>

export type SetCustomerCaptureSettingsMutation = {
  __typename: 'Mutation'
  setCustomerCaptureSettings: {
    __typename: 'CustomerCaptureSettings'
    automaticTransferEnabled: boolean
    disabledChecks: Array<DocumentCaptureCheck>
  }
}

export type SetCustomerPaywallMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isPaywalled: Scalars['Boolean']['input']
}>

export type SetCustomerPaywallMutation = {
  __typename: 'Mutation'
  setCustomerPaywall: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }
}

export type SetTenantMetabaseDashboardIdMutationVariables = Exact<{
  id: Scalars['ID']['input']
  metabaseDashboardId: Scalars['String']['input']
}>

export type SetTenantMetabaseDashboardIdMutation = {
  __typename: 'Mutation'
  setTenantMetabaseDashboardId: {
    __typename: 'Customer'
    id: string
    metabaseDashboardId?: string | null
  }
}

export type UpdateCustomerEmailMutationVariables = Exact<{
  email: Scalars['String']['input']
  id: Scalars['ID']['input']
}>

export type UpdateCustomerEmailMutation = {
  __typename: 'Mutation'
  updateCustomerEmail: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }
}

export type UpdateCustomerReturnScheduleMutationVariables = Exact<{
  data: CustomerReturnScheduleUpdateInput
  where: CustomerWhereUniqueInput
}>

export type UpdateCustomerReturnScheduleMutation = {
  __typename: 'Mutation'
  updateCustomerReturnSchedule: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }
}

export type UpdateCustomerScanCenterMutationVariables = Exact<{
  scanCenter: ScanCenterCode
  id: Scalars['ID']['input']
}>

export type UpdateCustomerScanCenterMutation = {
  __typename: 'Mutation'
  updateCustomer: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    metabaseDashboardId?: string | null
    newsletter: boolean
    returnsInterval?: ReturnsInterval | null
    scanCenter: ScanCenterCode
    paywalledAt?: any | null
    returnsAll: boolean
    returnsNextAt?: any | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    captureSettings: {
      __typename: 'CustomerCaptureSettings'
      automaticTransferEnabled: boolean
      disabledChecks: Array<DocumentCaptureCheck>
    }
  }
}

export type AssignTaggerDocumentsMutationVariables = Exact<{
  count: Scalars['Int']['input']
  where?: InputMaybe<DocumentWhereInput>
}>

export type AssignTaggerDocumentsMutation = {
  __typename: 'Mutation'
  assignTaggerDocuments: Array<{
    __typename: 'Document'
    id: string
    tagger?: string | null
  }>
}

export type ContainerDocumentFragment = {
  __typename: 'ContainerDocument'
  currentLocationType?: OriginalStateType | null
  id: string
  isDestroyed: boolean
  canReturn: boolean
  createdAt: any
  owner: { __typename: 'Customer'; id: string }
}

export type ContainerDocumentQueryVariables = Exact<{
  containerId: Scalars['ID']['input']
}>

export type ContainerDocumentQuery = {
  __typename: 'Query'
  containerDocument: {
    __typename: 'ContainerDocument'
    currentLocationType?: OriginalStateType | null
    id: string
    isDestroyed: boolean
    canReturn: boolean
    createdAt: any
    owner: { __typename: 'Customer'; id: string }
  }
}

export type ContainerReturnFragment = {
  __typename: 'ContainerReturn'
  id: string
  owner: {
    __typename: 'ContainerReturnOwner'
    id: string
    publicId: number
    encodedPublicId: string
  }
}

export type DocumentCustomerFragment = {
  __typename: 'Customer'
  id: string
  publicId?: number | null
  encodedPublicId: string
  planId: string
  email: string
  firstName?: string | null
  lastName?: string | null
  companyName?: string | null
  scanCenter: ScanCenterCode
  returnsAll: boolean
  createdAt: any
  updatedAt: any
}

export type DeleteUploadMutationVariables = Exact<{
  key: Scalars['String']['input']
}>

export type DeleteUploadMutation = {
  __typename: 'Mutation'
  deleteUpload: boolean
}

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteDocumentMutation = {
  __typename: 'Mutation'
  deleteDocument: { __typename: 'Document'; id: string }
}

export type DocumentFileTokenFragment = {
  __typename: 'Document'
  id: string
  fileToken: string
}

export type DocumentNatifMetadataFragment = {
  __typename: 'Document'
  id: string
  natifMetadata?: {
    __typename: 'DocumentNatifMetadata'
    date?: string | null
    scanId?: string | null
  } | null
}

export type DocumentPaymentMetadataFragment = {
  __typename: 'Document'
  id: string
  paymentMetadata?: {
    __typename: 'PaymentMetadata'
    iban?: string | null
    amount?: number | null
    recipient?: string | null
    reference?: string | null
  } | null
}

export type DocumentRecipientMetadataFragment = {
  __typename: 'Document'
  id: string
  recipientMetadata?: {
    __typename: 'DocumentRecipientMetadata'
    name?: string | null
  } | null
}

export type DocumentScanMetadataFragment = {
  __typename: 'Document'
  id: string
  scanMetadata?: {
    __typename: 'DocumentScanMetadata'
    date?: string | null
    scanId?: string | null
    sequenceId?: string | null
  } | null
}

export type DocumentSenderFragment = {
  __typename: 'Document'
  id: string
  senderMetadata?: {
    __typename: 'DocumentSenderMetadata'
    name?: string | null
    email?: string | null
    phone?: string | null
  } | null
}

export type DocumentSubjectFragment = {
  __typename: 'Document'
  id: string
  subject?: string | null
}

export type DocumentSubscribedFragment = {
  __typename: 'Document'
  id: string
  stage: DocumentStage
  createdAt: any
  updatedAt: any
  tagger?: string | null
  tags: Array<string>
  subject?: string | null
  customer?: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    scanCenter: ScanCenterCode
    returnsAll: boolean
    createdAt: any
    updatedAt: any
  } | null
  senderMetadata?: {
    __typename: 'DocumentSenderMetadata'
    name?: string | null
    email?: string | null
    phone?: string | null
  } | null
}

export type DocumentTaggerFragment = {
  __typename: 'Document'
  id: string
  tagger?: string | null
}

export type DocumentTagsFragment = {
  __typename: 'Document'
  id: string
  tags: Array<string>
}

export type DocumentFragment = {
  __typename: 'Document'
  id: string
  stage: DocumentStage
  scanCenter?: ScanCenterCode | null
  createdAt: any
  updatedAt: any
  tagger?: string | null
  tags: Array<string>
  subject?: string | null
  customer?: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    scanCenter: ScanCenterCode
    returnsAll: boolean
    createdAt: any
    updatedAt: any
  } | null
  rules?: Array<{
    __typename: 'DocumentRule'
    metadata?: any | null
    severity: DocumentRuleSeverity
    type: DocumentRuleType
    id: string
  }> | null
  senderMetadata?: {
    __typename: 'DocumentSenderMetadata'
    name?: string | null
    email?: string | null
    phone?: string | null
  } | null
  paymentMetadata?: {
    __typename: 'PaymentMetadata'
    iban?: string | null
    amount?: number | null
    recipient?: string | null
    reference?: string | null
  } | null
  natifMetadata?: {
    __typename: 'DocumentNatifMetadata'
    date?: string | null
    scanId?: string | null
  } | null
  scanMetadata?: {
    __typename: 'DocumentScanMetadata'
    date?: string | null
    scanId?: string | null
    sequenceId?: string | null
  } | null
  recipientMetadata?: {
    __typename: 'DocumentRecipientMetadata'
    name?: string | null
  } | null
}

export type OneDocumentQueryVariables = Exact<{
  where: DocumentWhereUniqueInput
}>

export type OneDocumentQuery = {
  __typename: 'Query'
  document: {
    __typename: 'Document'
    id: string
    stage: DocumentStage
    scanCenter?: ScanCenterCode | null
    createdAt: any
    updatedAt: any
    tagger?: string | null
    tags: Array<string>
    subject?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      scanCenter: ScanCenterCode
      returnsAll: boolean
      createdAt: any
      updatedAt: any
    } | null
    rules?: Array<{
      __typename: 'DocumentRule'
      metadata?: any | null
      severity: DocumentRuleSeverity
      type: DocumentRuleType
      id: string
    }> | null
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
    scanMetadata?: {
      __typename: 'DocumentScanMetadata'
      date?: string | null
      scanId?: string | null
      sequenceId?: string | null
    } | null
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  }
}

export type DocumentsInOpenReturnQueryVariables = Exact<{
  customerId: Scalars['ID']['input']
}>

export type DocumentsInOpenReturnQuery = {
  __typename: 'Query'
  documentsInOpenReturn: Array<{
    __typename: 'ContainerDocument'
    currentLocationType?: OriginalStateType | null
    id: string
    isDestroyed: boolean
    canReturn: boolean
    createdAt: any
    owner: { __typename: 'Customer'; id: string }
  }>
}

export type FailedDocumentsQueryVariables = Exact<{ [key: string]: never }>

export type FailedDocumentsQuery = {
  __typename: 'Query'
  failedDocuments: Array<{
    __typename: 'IncorrectOrRejectedFile'
    key: string
    type: FailedDocumentType
    file: string
  }>
}

export type FetchDocumentFileTokenQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FetchDocumentFileTokenQuery = {
  __typename: 'Query'
  document: { __typename: 'Document'; id: string; fileToken: string }
}

export type OpenDocumentsQueryVariables = Exact<{
  where?: InputMaybe<DocumentWhereInput>
  first?: InputMaybe<Scalars['Int']['input']>
}>

export type OpenDocumentsQuery = {
  __typename: 'Query'
  documents: Array<{
    __typename: 'Document'
    id: string
    stage: DocumentStage
    scanCenter?: ScanCenterCode | null
    createdAt: any
    updatedAt: any
    tagger?: string | null
    tags: Array<string>
    subject?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      scanCenter: ScanCenterCode
      returnsAll: boolean
      createdAt: any
      updatedAt: any
    } | null
    rules?: Array<{
      __typename: 'DocumentRule'
      metadata?: any | null
      severity: DocumentRuleSeverity
      type: DocumentRuleType
      id: string
    }> | null
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
    scanMetadata?: {
      __typename: 'DocumentScanMetadata'
      date?: string | null
      scanId?: string | null
      sequenceId?: string | null
    } | null
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  }>
}

export type ReAssignDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input']
  data: CustomerWhereByEmailOrEncodedPublicIdInput
}>

export type ReAssignDocumentMutation = {
  __typename: 'Mutation'
  reAssignDocument?: {
    __typename: 'Document'
    id: string
    stage: DocumentStage
    scanCenter?: ScanCenterCode | null
    createdAt: any
    updatedAt: any
    tagger?: string | null
    tags: Array<string>
    subject?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      scanCenter: ScanCenterCode
      returnsAll: boolean
      createdAt: any
      updatedAt: any
    } | null
    rules?: Array<{
      __typename: 'DocumentRule'
      metadata?: any | null
      severity: DocumentRuleSeverity
      type: DocumentRuleType
      id: string
    }> | null
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
    scanMetadata?: {
      __typename: 'DocumentScanMetadata'
      date?: string | null
      scanId?: string | null
      sequenceId?: string | null
    } | null
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  } | null
}

export type RenameUploadMutationVariables = Exact<{
  key: Scalars['String']['input']
  newFileName: Scalars['String']['input']
}>

export type RenameUploadMutation = {
  __typename: 'Mutation'
  renameUpload: boolean
}

export type ReportNatifExtractionErrorsMutationVariables = Exact<{
  data: NatifExtractionErrorsInput
  where: NatifExtractionErrorsWhereInput
}>

export type ReportNatifExtractionErrorsMutation = {
  __typename: 'Mutation'
  reportNatifExtractionErrors: boolean
}

export type RequestReturnMutationVariables = Exact<{
  customerId: Scalars['ID']['input']
}>

export type RequestReturnMutation = {
  __typename: 'Mutation'
  requestReturn: Array<{
    __typename: 'ContainerReturn'
    id: string
    owner: {
      __typename: 'ContainerReturnOwner'
      id: string
      publicId: number
      encodedPublicId: string
    }
  }>
}

export type SendContainerDocumentMutationVariables = Exact<{
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type SendContainerDocumentMutation = {
  __typename: 'Mutation'
  sendContainerDocument: {
    __typename: 'ContainerDocument'
    currentLocationType?: OriginalStateType | null
    id: string
    isDestroyed: boolean
    canReturn: boolean
    createdAt: any
    owner: { __typename: 'Customer'; id: string }
  }
}

export type UnDeleteContainerDocumentMutationVariables = Exact<{
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type UnDeleteContainerDocumentMutation = {
  __typename: 'Mutation'
  unDeleteContainerDocument: {
    __typename: 'ContainerDocument'
    currentLocationType?: OriginalStateType | null
    id: string
    isDestroyed: boolean
    canReturn: boolean
    createdAt: any
    owner: { __typename: 'Customer'; id: string }
  }
}

export type UnShredContainerDocumentMutationVariables = Exact<{
  containerId: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type UnShredContainerDocumentMutation = {
  __typename: 'Mutation'
  unShredContainerDocument: {
    __typename: 'ContainerDocument'
    currentLocationType?: OriginalStateType | null
    id: string
    isDestroyed: boolean
    canReturn: boolean
    createdAt: any
    owner: { __typename: 'Customer'; id: string }
  }
}

export type UnassignDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UnassignDocumentMutation = {
  __typename: 'Mutation'
  unassignDocument?: { __typename: 'Document'; id: string } | null
}

export type UpdateDocumentNatifMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input']
  natifMetadata?: InputMaybe<DocumentNatifMetadataUpdateInput>
}>

export type UpdateDocumentNatifMetadataMutation = {
  __typename: 'Mutation'
  updateDocument: {
    __typename: 'Document'
    id: string
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
  }
}

export type UpdateDocumentPaymentMetadataMutationVariables = Exact<{
  documentId: Scalars['ID']['input']
  data: PaymentMetadataCreateWithoutDocumentInput
}>

export type UpdateDocumentPaymentMetadataMutation = {
  __typename: 'Mutation'
  upsertPaymentMetadata: {
    __typename: 'Document'
    id: string
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
  }
}

export type UpdateDocumentRecipientMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input']
  recipientMetadata?: InputMaybe<DocumentRecipientMetadataUpdateInput>
}>

export type UpdateDocumentRecipientMetadataMutation = {
  __typename: 'Mutation'
  updateDocument: {
    __typename: 'Document'
    id: string
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  }
}

export type UpdateDocumentSenderMutationVariables = Exact<{
  id: Scalars['ID']['input']
  sender: DocumentSenderMetadataUpdateInput
}>

export type UpdateDocumentSenderMutation = {
  __typename: 'Mutation'
  updateDocument: {
    __typename: 'Document'
    id: string
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
  }
}

export type UpdateDocumentStageMutationVariables = Exact<{
  id: Scalars['ID']['input']
  stage: DocumentStage
}>

export type UpdateDocumentStageMutation = {
  __typename: 'Mutation'
  updateDocument: {
    __typename: 'Document'
    id: string
    stage: DocumentStage
    scanCenter?: ScanCenterCode | null
    createdAt: any
    updatedAt: any
    tagger?: string | null
    tags: Array<string>
    subject?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      scanCenter: ScanCenterCode
      returnsAll: boolean
      createdAt: any
      updatedAt: any
    } | null
    rules?: Array<{
      __typename: 'DocumentRule'
      metadata?: any | null
      severity: DocumentRuleSeverity
      type: DocumentRuleType
      id: string
    }> | null
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
    scanMetadata?: {
      __typename: 'DocumentScanMetadata'
      date?: string | null
      scanId?: string | null
      sequenceId?: string | null
    } | null
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  }
}

export type UpdateDocumentSubjectMutationVariables = Exact<{
  id: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateDocumentSubjectMutation = {
  __typename: 'Mutation'
  updateDocument: {
    __typename: 'Document'
    id: string
    subject?: string | null
  }
}

export type UpdateDocumentTagsMutationVariables = Exact<{
  id: Scalars['ID']['input']
  tags: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type UpdateDocumentTagsMutation = {
  __typename: 'Mutation'
  updateDocument: { __typename: 'Document'; id: string; tags: Array<string> }
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
  __typename: 'Query'
  me: { __typename: 'User'; username: string; groups: Array<string> }
}

export type ReturnAddressFragment = {
  __typename: 'Address'
  id: string
  lines: Array<string>
  streetAddress?: string | null
  city?: string | null
  zip?: string | null
  countryCode: string
  createdAt: any
  updatedAt: any
}

export type ReturnCustomerFragment = {
  __typename: 'ContainerReturnOwner'
  id: string
  publicId: number
  encodedPublicId: string
}

export type ReturnDocumentFragment = {
  __typename: 'ContainerDocument'
  id: string
  subject?: string | null
  tags: Array<string>
  scanCenter?: ScanCenterCode | null
  returnId?: string | null
  documentId: string
  createdAt: any
  updatedAt: any
  senderMetadata?: {
    __typename: 'DocumentSenderMetadata'
    name?: string | null
    email?: string | null
    phone?: string | null
  } | null
  scanMetadata?: {
    __typename: 'DocumentScanMetadata'
    scanId?: string | null
  } | null
}

export type RequestedDocumentsQueryVariables = Exact<{
  returnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  count?: InputMaybe<Scalars['Int']['input']>
}>

export type RequestedDocumentsQuery = {
  __typename: 'Query'
  containersConnection: {
    __typename: 'ContainerConnection'
    edges: Array<{
      __typename: 'ContainerEdge'
      cursor: string
      node:
        | {
            __typename: 'ContainerDocument'
            id: string
            subject?: string | null
            tags: Array<string>
            scanCenter?: ScanCenterCode | null
            returnId?: string | null
            documentId: string
            createdAt: any
            updatedAt: any
            senderMetadata?: {
              __typename: 'DocumentSenderMetadata'
              name?: string | null
              email?: string | null
              phone?: string | null
            } | null
            scanMetadata?: {
              __typename: 'DocumentScanMetadata'
              scanId?: string | null
            } | null
          }
        | { __typename: 'ContainerReturn' }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      startCursor?: string | null
      endCursor?: string | null
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
    aggregate: { __typename: 'AggregateContainer'; count: number }
  }
}

export type RequestedReturnsQueryVariables = Exact<{
  where: ContainerWhereInput
  cursor?: InputMaybe<Scalars['String']['input']>
  count?: InputMaybe<Scalars['Int']['input']>
}>

export type RequestedReturnsQuery = {
  __typename: 'Query'
  containersConnection: {
    __typename: 'ContainerConnection'
    edges: Array<{
      __typename: 'ContainerEdge'
      cursor: string
      node:
        | { __typename: 'ContainerDocument' }
        | {
            __typename: 'ContainerReturn'
            id: string
            type: ContainerTypeReturn
            requestedAt?: any | null
            sentAt?: any | null
            address?: {
              __typename: 'Address'
              id: string
              lines: Array<string>
              streetAddress?: string | null
              city?: string | null
              zip?: string | null
              countryCode: string
              createdAt: any
              updatedAt: any
            } | null
            requesterUser: {
              __typename: 'ContainerReturnRequesterUser'
              email?: string | null
            }
            owner: {
              __typename: 'ContainerReturnOwner'
              id: string
              publicId: number
              encodedPublicId: string
            }
          }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      startCursor?: string | null
      endCursor?: string | null
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
    aggregate: { __typename: 'AggregateContainer'; count: number }
  }
}

export type ReturnFragment = {
  __typename: 'ContainerReturn'
  id: string
  type: ContainerTypeReturn
  requestedAt?: any | null
  sentAt?: any | null
  address?: {
    __typename: 'Address'
    id: string
    lines: Array<string>
    streetAddress?: string | null
    city?: string | null
    zip?: string | null
    countryCode: string
    createdAt: any
    updatedAt: any
  } | null
  requesterUser: {
    __typename: 'ContainerReturnRequesterUser'
    email?: string | null
  }
  owner: {
    __typename: 'ContainerReturnOwner'
    id: string
    publicId: number
    encodedPublicId: string
  }
}

export type SendReturnMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type SendReturnMutation = {
  __typename: 'Mutation'
  sendReturn: {
    __typename: 'ContainerReturn'
    id: string
    type: ContainerTypeReturn
    requestedAt?: any | null
    sentAt?: any | null
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
    requesterUser: {
      __typename: 'ContainerReturnRequesterUser'
      email?: string | null
    }
    owner: {
      __typename: 'ContainerReturnOwner'
      id: string
      publicId: number
      encodedPublicId: string
    }
  }
}

export type SendReturnsWithTrackingIdsMutationVariables = Exact<{
  data: Array<SetReturnTrackingIdInput> | SetReturnTrackingIdInput
}>

export type SendReturnsWithTrackingIdsMutation = {
  __typename: 'Mutation'
  setManyReturnTrackingIds: { __typename: 'BatchPayload'; count: number }
}

export type SourceAddressFragment = {
  __typename: 'Address'
  id: string
  lines: Array<string>
  streetAddress?: string | null
  city?: string | null
  zip?: string | null
  countryCode: string
  createdAt: any
  updatedAt: any
}

export type CloneSourceMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CloneSourceMutation = {
  __typename: 'Mutation'
  cloneSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type SourceCustomerFragment = {
  __typename: 'Customer'
  id: string
  publicId?: number | null
  encodedPublicId: string
  planId: string
  email: string
  firstName?: string | null
  lastName?: string | null
  companyName?: string | null
  returnsAll: boolean
  createdAt: any
  updatedAt: any
  address?: {
    __typename: 'Address'
    id: string
    lines: Array<string>
    streetAddress?: string | null
    city?: string | null
    zip?: string | null
    countryCode: string
    createdAt: any
    updatedAt: any
  } | null
}

export type RequestedSourcesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>
  count?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SourceWhereInput>
}>

export type RequestedSourcesQuery = {
  __typename: 'Query'
  sourcesConnection: {
    __typename: 'SourceConnection'
    edges: Array<{
      __typename: 'SourceEdge'
      cursor: string
      node: {
        __typename: 'Source'
        id: string
        stage: SourceStage
        title?: string | null
        scanCenter: ScanCenterCode
        metadata: any
        duration?: SourceInterval | null
        createdAt: any
        updatedAt: any
        startAt?: any | null
        endAt?: any | null
        externalId?: string | null
        address: {
          __typename: 'Address'
          id: string
          lines: Array<string>
          streetAddress?: string | null
          city?: string | null
          zip?: string | null
          countryCode: string
          createdAt: any
          updatedAt: any
        }
        customer: {
          __typename: 'Customer'
          id: string
          publicId?: number | null
          encodedPublicId: string
          planId: string
          email: string
          firstName?: string | null
          lastName?: string | null
          companyName?: string | null
          returnsAll: boolean
          createdAt: any
          updatedAt: any
          address?: {
            __typename: 'Address'
            id: string
            lines: Array<string>
            streetAddress?: string | null
            city?: string | null
            zip?: string | null
            countryCode: string
            createdAt: any
            updatedAt: any
          } | null
        }
      }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      startCursor?: string | null
      endCursor?: string | null
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
    aggregate: { __typename: 'AggregateSource'; count: number }
  }
}

export type SourceFragment = {
  __typename: 'Source'
  id: string
  stage: SourceStage
  title?: string | null
  scanCenter: ScanCenterCode
  metadata: any
  duration?: SourceInterval | null
  createdAt: any
  updatedAt: any
  startAt?: any | null
  endAt?: any | null
  externalId?: string | null
  address: {
    __typename: 'Address'
    id: string
    lines: Array<string>
    streetAddress?: string | null
    city?: string | null
    zip?: string | null
    countryCode: string
    createdAt: any
    updatedAt: any
  }
  customer: {
    __typename: 'Customer'
    id: string
    publicId?: number | null
    encodedPublicId: string
    planId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    returnsAll: boolean
    createdAt: any
    updatedAt: any
    address?: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    } | null
  }
}

export type UpdateSourceAddressMutationVariables = Exact<{
  id: Scalars['ID']['input']
  data: AddressUpdateInput
}>

export type UpdateSourceAddressMutation = {
  __typename: 'Mutation'
  setSourceAddress: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateSourceDatesMutationVariables = Exact<{
  id: Scalars['ID']['input']
  startAt?: InputMaybe<Scalars['DateTime']['input']>
}>

export type UpdateSourceDatesMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateSourceDurationMutationVariables = Exact<{
  id: Scalars['ID']['input']
  duration: SourceInterval
}>

export type UpdateSourceDurationMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateExternalIdMutationVariables = Exact<{
  id: Scalars['ID']['input']
  externalId?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateExternalIdMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateSourceMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input']
  metadata: Scalars['Json']['input']
}>

export type UpdateSourceMetadataMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateScanCenterMutationVariables = Exact<{
  id: Scalars['ID']['input']
  scanCenter: ScanCenterCode
}>

export type UpdateScanCenterMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateSourceExtIdStartDateAndStageMutationVariables = Exact<{
  id: Scalars['ID']['input']
  startAt: Scalars['DateTime']['input']
  externalID: Scalars['String']['input']
}>

export type UpdateSourceExtIdStartDateAndStageMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type UpdateSourceStageMutationVariables = Exact<{
  id: Scalars['ID']['input']
  stage: SourceStage
}>

export type UpdateSourceStageMutation = {
  __typename: 'Mutation'
  updateSource: {
    __typename: 'Source'
    id: string
    stage: SourceStage
    title?: string | null
    scanCenter: ScanCenterCode
    metadata: any
    duration?: SourceInterval | null
    createdAt: any
    updatedAt: any
    startAt?: any | null
    endAt?: any | null
    externalId?: string | null
    address: {
      __typename: 'Address'
      id: string
      lines: Array<string>
      streetAddress?: string | null
      city?: string | null
      zip?: string | null
      countryCode: string
      createdAt: any
      updatedAt: any
    }
    customer: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      returnsAll: boolean
      createdAt: any
      updatedAt: any
      address?: {
        __typename: 'Address'
        id: string
        lines: Array<string>
        streetAddress?: string | null
        city?: string | null
        zip?: string | null
        countryCode: string
        createdAt: any
        updatedAt: any
      } | null
    }
  }
}

export type DocumentSearchContainerIdQueryVariables = Exact<{
  containerId: Scalars['ID']['input']
}>

export type DocumentSearchContainerIdQuery = {
  __typename: 'Query'
  containerDocument: { __typename: 'ContainerDocument'; documentId: string }
}

export type DocumentSearchDocumentIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DocumentSearchDocumentIdQuery = {
  __typename: 'Query'
  document: {
    __typename: 'Document'
    id: string
    stage: DocumentStage
    scanCenter?: ScanCenterCode | null
    createdAt: any
    updatedAt: any
    tagger?: string | null
    tags: Array<string>
    subject?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      publicId?: number | null
      encodedPublicId: string
      planId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      companyName?: string | null
      scanCenter: ScanCenterCode
      returnsAll: boolean
      createdAt: any
      updatedAt: any
    } | null
    rules?: Array<{
      __typename: 'DocumentRule'
      metadata?: any | null
      severity: DocumentRuleSeverity
      type: DocumentRuleType
      id: string
    }> | null
    senderMetadata?: {
      __typename: 'DocumentSenderMetadata'
      name?: string | null
      email?: string | null
      phone?: string | null
    } | null
    paymentMetadata?: {
      __typename: 'PaymentMetadata'
      iban?: string | null
      amount?: number | null
      recipient?: string | null
      reference?: string | null
    } | null
    natifMetadata?: {
      __typename: 'DocumentNatifMetadata'
      date?: string | null
      scanId?: string | null
    } | null
    scanMetadata?: {
      __typename: 'DocumentScanMetadata'
      date?: string | null
      scanId?: string | null
      sequenceId?: string | null
    } | null
    recipientMetadata?: {
      __typename: 'DocumentRecipientMetadata'
      name?: string | null
    } | null
  }
}

export const CustomerAddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerAddressFragment, unknown>
export const CustomerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFragment, unknown>
export const ContainerDocumentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContainerDocumentFragment, unknown>
export const ReturnCustomerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReturnCustomerFragment, unknown>
export const ContainerReturnFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerReturn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContainerReturnFragment, unknown>
export const DocumentFileTokenFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFileToken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileToken' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentFileTokenFragment, unknown>
export const DocumentTaggerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentTaggerFragment, unknown>
export const DocumentTagsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentTagsFragment, unknown>
export const DocumentSenderFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentSenderFragment, unknown>
export const DocumentSubjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentSubjectFragment, unknown>
export const DocumentCustomerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentCustomerFragment, unknown>
export const DocumentSubscribedFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubscribed' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentSubscribedFragment, unknown>
export const DocumentPaymentMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentPaymentMetadataFragment, unknown>
export const DocumentNatifMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentNatifMetadataFragment, unknown>
export const DocumentScanMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentScanMetadataFragment, unknown>
export const DocumentRecipientMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentRecipientMetadataFragment, unknown>
export const DocumentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentFragment, unknown>
export const ReturnDocumentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReturnDocumentFragment, unknown>
export const ReturnAddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReturnAddressFragment, unknown>
export const ReturnFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Return' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requesterUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReturnFragment, unknown>
export const SourceAddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceAddressFragment, unknown>
export const SourceCustomerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceCustomerFragment, unknown>
export const SourceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceFragment, unknown>
export const CustomersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Customers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerWhereInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '20' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomersQuery, CustomersQueryVariables>
export const DisableCustomerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisableCustomer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableCustomer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableCustomerMutation,
  DisableCustomerMutationVariables
>
export const FetchTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'publicId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'publicId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'streetAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTenantQuery, FetchTenantQueryVariables>
export const FindCustomerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindCustomer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findCustomers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindCustomerQuery, FindCustomerQueryVariables>
export const SetCustomerCaptureSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setCustomerCaptureSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerCaptureSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCustomerCaptureSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCustomerCaptureSettingsMutation,
  SetCustomerCaptureSettingsMutationVariables
>
export const SetCustomerPaywallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setCustomerPaywall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isPaywalled' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCustomerPaywall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isPaywalled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isPaywalled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCustomerPaywallMutation,
  SetCustomerPaywallMutationVariables
>
export const SetTenantMetabaseDashboardIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetTenantMetabaseDashboardId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setTenantMetabaseDashboardId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metabaseDashboardId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metabaseDashboardId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metabaseDashboardId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetTenantMetabaseDashboardIdMutation,
  SetTenantMetabaseDashboardIdMutationVariables
>
export const UpdateCustomerEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCustomerEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomerEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCustomerEmailMutation,
  UpdateCustomerEmailMutationVariables
>
export const UpdateCustomerReturnScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCustomerReturnSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CustomerReturnScheduleUpdateInput',
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerWhereUniqueInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomerReturnSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCustomerReturnScheduleMutation,
  UpdateCustomerReturnScheduleMutationVariables
>
export const UpdateCustomerScanCenterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCustomerScanCenter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'scanCenter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ScanCenterCode' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scanCenter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'scanCenter' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Customer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Customer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metabaseDashboardId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'newsletter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsInterval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerAddress' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'captureSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automaticTransferEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disabledChecks' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paywalledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsNextAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCustomerScanCenterMutation,
  UpdateCustomerScanCenterMutationVariables
>
export const AssignTaggerDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignTaggerDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentWhereInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignTaggerDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentTagger' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignTaggerDocumentsMutation,
  AssignTaggerDocumentsMutationVariables
>
export const ContainerDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContainerDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'containerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containerDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'containerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'containerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerDocument' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContainerDocumentQuery,
  ContainerDocumentQueryVariables
>
export const DeleteUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'key' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'key' },
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteUploadMutation,
  DeleteUploadMutationVariables
>
export const DeleteDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>
export const OneDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OneDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DocumentWhereUniqueInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'document' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Document' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OneDocumentQuery, OneDocumentQueryVariables>
export const DocumentsInOpenReturnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentsInOpenReturn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentsInOpenReturn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerDocument' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentsInOpenReturnQuery,
  DocumentsInOpenReturnQueryVariables
>
export const FailedDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FailedDocuments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'failedDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'file' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FailedDocumentsQuery,
  FailedDocumentsQueryVariables
>
export const FetchDocumentFileTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchDocumentFileToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'document' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentFileToken' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFileToken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileToken' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchDocumentFileTokenQuery,
  FetchDocumentFileTokenQueryVariables
>
export const OpenDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OpenDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentWhereInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Document' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpenDocumentsQuery, OpenDocumentsQueryVariables>
export const ReAssignDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReAssignDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CustomerWhereByEmailOrEncodedPublicIdInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reAssignDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'documentId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Document' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReAssignDocumentMutation,
  ReAssignDocumentMutationVariables
>
export const RenameUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenameUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newFileName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renameUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newFileName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newFileName' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'key' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'key' },
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RenameUploadMutation,
  RenameUploadMutationVariables
>
export const ReportNatifExtractionErrorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReportNatifExtractionErrors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NatifExtractionErrorsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NatifExtractionErrorsWhereInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportNatifExtractionErrors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportNatifExtractionErrorsMutation,
  ReportNatifExtractionErrorsMutationVariables
>
export const RequestReturnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestReturn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestReturn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerReturn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerReturn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestReturnMutation,
  RequestReturnMutationVariables
>
export const SendContainerDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendContainerDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'containerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendContainerDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'containerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'containerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerDocument' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendContainerDocumentMutation,
  SendContainerDocumentMutationVariables
>
export const UnDeleteContainerDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnDeleteContainerDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'containerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unDeleteContainerDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'containerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'containerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerDocument' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnDeleteContainerDocumentMutation,
  UnDeleteContainerDocumentMutationVariables
>
export const UnShredContainerDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnShredContainerDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'containerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unShredContainerDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'containerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'containerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContainerDocument' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContainerDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocationType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDestroyed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReturn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnShredContainerDocumentMutation,
  UnShredContainerDocumentMutationVariables
>
export const UnassignDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnassignDocumentMutation,
  UnassignDocumentMutationVariables
>
export const UpdateDocumentNatifMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentNatifMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'natifMetadata' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentNatifMetadataUpdateInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'natifMetadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'natifMetadata' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentNatifMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentNatifMetadataMutation,
  UpdateDocumentNatifMetadataMutationVariables
>
export const UpdateDocumentPaymentMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentPaymentMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PaymentMetadataCreateWithoutDocumentInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertPaymentMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'documentId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentPaymentMetadataMutation,
  UpdateDocumentPaymentMetadataMutationVariables
>
export const UpdateDocumentRecipientMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentRecipientMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientMetadata' },
          },
          type: {
            kind: 'NamedType',
            name: {
              kind: 'Name',
              value: 'DocumentRecipientMetadataUpdateInput',
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientMetadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'recipientMetadata' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentRecipientMetadataMutation,
  UpdateDocumentRecipientMetadataMutationVariables
>
export const UpdateDocumentSenderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentSender' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sender' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DocumentSenderMetadataUpdateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sender' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'sender' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentSender' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentSenderMutation,
  UpdateDocumentSenderMutationVariables
>
export const UpdateDocumentStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stage' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DocumentStage' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stage' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'stage' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Document' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentStageMutation,
  UpdateDocumentStageMutationVariables
>
export const UpdateDocumentSubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentSubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subject' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subject' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'subject' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentSubject' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentSubjectMutation,
  UpdateDocumentSubjectMutationVariables
>
export const UpdateDocumentTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDocumentTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tags' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'set' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'tags' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentTags' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDocumentTagsMutation,
  UpdateDocumentTagsMutationVariables
>
export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Me' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groups' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>
export const RequestedDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestedDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'returnIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containersConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'DocumentScan' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadataOriginal' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'currentLocation' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id_in' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'returnIds' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'ContainerDocument',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ReturnDocument',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestedDocumentsQuery,
  RequestedDocumentsQueryVariables
>
export const RequestedReturnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestedReturns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContainerWhereInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containersConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'ContainerReturn',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Return' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Return' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requesterUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestedReturnsQuery,
  RequestedReturnsQueryVariables
>
export const SendReturnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReturn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReturn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Return' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReturnCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturnOwner' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Return' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContainerReturn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requesterUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReturnCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendReturnMutation, SendReturnMutationVariables>
export const SendReturnsWithTrackingIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReturnsWithTrackingIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'SetReturnTrackingIdInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setManyReturnTrackingIds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendReturnsWithTrackingIdsMutation,
  SendReturnsWithTrackingIdsMutationVariables
>
export const CloneSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CloneSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloneSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CloneSourceMutation, CloneSourceMutationVariables>
export const RequestedSourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestedSources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SourceWhereInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sourcesConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'createdAt_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Source' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestedSourcesQuery,
  RequestedSourcesQueryVariables
>
export const UpdateSourceAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddressUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setSourceAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceAddressMutation,
  UpdateSourceAddressMutationVariables
>
export const UpdateSourceDatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DateTime' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startAt' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'startAt' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceDatesMutation,
  UpdateSourceDatesMutationVariables
>
export const UpdateSourceDurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceDuration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'duration' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SourceInterval' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'duration' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceDurationMutation,
  UpdateSourceDurationMutationVariables
>
export const UpdateExternalIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateExternalId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'externalId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'externalId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateExternalIdMutation,
  UpdateExternalIdMutationVariables
>
export const UpdateSourceMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Json' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceMetadataMutation,
  UpdateSourceMetadataMutationVariables
>
export const UpdateScanCenterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScanCenter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'scanCenter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ScanCenterCode' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scanCenter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'scanCenter' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateScanCenterMutation,
  UpdateScanCenterMutationVariables
>
export const UpdateSourceExtIdStartDateAndStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceExtIdStartDateAndStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startAt' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalID' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startAt' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'startAt' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'externalId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'externalID' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stage' },
                      value: { kind: 'EnumValue', value: 'Activating' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceExtIdStartDateAndStageMutation,
  UpdateSourceExtIdStartDateAndStageMutationVariables
>
export const UpdateSourceStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSourceStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stage' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SourceStage' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stage' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'stage' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Source' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceAddress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Address' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lines' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SourceCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Source' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Source' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceAddress' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SourceCustomer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSourceStageMutation,
  UpdateSourceStageMutationVariables
>
export const DocumentSearchContainerIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'documentSearchContainerId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'containerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'containerDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'containerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'containerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentSearchContainerIdQuery,
  DocumentSearchContainerIdQueryVariables
>
export const DocumentSearchDocumentIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'documentSearchDocumentId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'document' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Document' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentCustomer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Customer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedPublicId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnsAll' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTagger' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagger' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSender' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentSubject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentNatifMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'natifMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentScanMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scanMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sequenceId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Document' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Document' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scanCenter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DocumentCustomer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTagger' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentTags' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSender' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentSubject' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentPaymentMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentNatifMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentScanMetadata' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'DocumentRecipientMetadata' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentSearchDocumentIdQuery,
  DocumentSearchDocumentIdQueryVariables
>
